module.exports = require("@gauzy/core");